export const commonStyles = theme => {
  return {
    container: {
      padding: 0,
      [theme.breakpoints.up('sm')]: {
        paddingLeft: '10%',
        paddingRight: '10%',
      },
      [theme.breakpoints.up('md')]: {
        paddingLeft: '120px',
        paddingRight: '120px',
      },
      maxWidth: '1440px'
    },
    header: {
      padding: theme.spacing(0, 2),
      [theme.breakpoints.up('sm')]: {
        padding: 0
      },
      '& img': {
        padding: theme.spacing(2, 0)
      }
    },
    form: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(4, 2),
      border: '1px solid #c4c4c4',
      borderRadius: '3px',
      boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.2)',
      '& .MuiGrid-item': {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
      },
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(4, 8)
      }
    },
    formTitle: {
      [theme.breakpoints.up('md')]: {
        marginLeft: '-2rem',
        marginRight: '-2rem',
        marginBottom: '2.3125rem !important',
      }
    },
    itemDisplayName: {
      marginRight: theme.spacing(0.5)
    },
    maintenanceForm: {
      [theme.breakpoints.up('sm')]: {
        marginTop: '57px',
      },
      [theme.breakpoints.up('md')]: {
        marginLeft: '33px',
      },
      [theme.breakpoints.up('lg')]: {
        marginLeft: '42px',
      },
    },
    wrapperFaqHome: {
      paddingTop: '0px',
      paddingBottom: '10rem',
      marginTop: "-18px",
    },
    legalText: {
     fontSize: '12px',
     color: theme.palette.text.light,
     lineHeight: '14px',
     marginBottom: '20px',
    },
    orderForm: {
      [theme.breakpoints.up('md')]: {
        maxWidth: '768px'
      }
    },
    quoteForm: {
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(4, 5)
      },
      [theme.breakpoints.up('md')]: {
        maxWidth: '368px'
      }
    },
    section: {
      paddingTop: `${theme.spacing(4)}px!important`
    },
    sectionTitle: {
      paddingTop: `${theme.spacing(3)}px!important`,
      paddingBottom: '0!important'
    },
    textField: {
      '& .MuiInput-underline:after': {
        borderBottomColor: theme.palette.primary
      }
    },
    select: {
      marginTop: theme.spacing(2),
      '&:after': {
        borderBottomColor: theme.palette.primary
      },
      '& > .MuiSvgIcon-root': {
        height: '100%',
        top: 0
      },
      '& .MuiIconButton-root': {
        padding: 0
      }
    },
    datePicker: {
      marginTop: 0
    },
    terms: {
      position: 'relative',
      color: theme.palette.text.light,
      padding: theme.spacing(3, 0),
      alignItems: 'flex-start',
      '& .MuiCheckbox-root': {
        position: 'absolute',
        top: `calc(${theme.spacing(3)}px - 9px)`
      },
      '& .MuiFormControlLabel-label': {
        marginLeft: '42px'
      }
    },
    button: {
      textTransform: 'none',
      '& .MuiCircularProgress-colorPrimary': {
        color: theme.palette.common.white
      },
      height: '62px',
      fontSize: '20px',
      fontWeight: 400
    },
    'expanded': {
      whiteSpace: 'normal !important',
      flexBasis: '50% !important'
    }
  };
};
